module.exports = __webpack_public_path__ + "static/img/15203007741.c0a396e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/15203007741.jpg
// module id = 6xkc
// module chunks = 0